export const mapSettings = {
  initialViewMode: 'fullMap', // 'autoZoom' | 'fullMap'
};

export const mapAssets = {
  basement: require('@/assets/maps/basement.png'),
  ground: require('@/assets/maps/ground.png'),
  floor: require('@/assets/maps/floor.png'),
  floor8: require('@/assets/maps/floor8.png'),
};


export const propertyMapItems = {
  parkings: {
        "1": {
            "label": "חניה 1",
            "x": 23.68,
            "y": 38.87,
            "width": 6.73,
            "height": 4.76
        },
        "2": {
            "label": "חניה 2",
            "x": 23.89,
            "y": 34.31,
            "width": 7.73,
            "height": 4.76
        },
        "3": {
            "label": "חניה 3",
            "x": 24.47,
            "y": 24.59,
            "width": 6.52,
            "height": 4.66
        },
        "4": {
            "label": "חניה 4",
            "x": 24.4,
            "y": 19.53,
            "width": 6.8,
            "height": 5.26
        },
        "5": {
            "label": "חניה 5",
            "x": 12.87,
            "y": 23.89,
            "width": 3.15,
            "height": 9.31
        },
        "6": {
            "label": "חניה 6",
            "x": 12.73,
            "y": 11.94,
            "width": 3.22,
            "height": 12.04
        },
        "7": {
            "label": "חניה 7",
            "x": 44.08,
            "y": 19.03,
            "width": 6.73,
            "height": 4.96
        },
        "8": {
            "label": "חניה 8",
            "x": 44.08,
            "y": 24.19,
            "width": 6.8,
            "height": 5.06
        },
        "9": {
            "label": "חניה 9",
            "x": 43.94,
            "y": 29.65,
            "width": 6.87,
            "height": 4.86
        },
        "10": {
            "label": "חניה 10",
            "x": 44.16,
            "y": 34.61,
            "width": 6.66,
            "height": 5.06
        },
        "11": {
            "label": "חניה 11",
            "x": 43.94,
            "y": 39.37,
            "width": 6.94,
            "height": 4.96
        },
        "12": {
            "label": "חניה 12",
            "x": 44.08,
            "y": 44.53,
            "width": 6.66,
            "height": 4.96
        },
        "13": {
            "label": "חניה 13",
            "x": 43.8,
            "y": 49.39,
            "width": 7.16,
            "height": 5.26
        },
        "14": {
            "label": "חניה 14",
            "x": 39.86,
            "y": 48.99,
            "width": 3.72,
            "height": 9.51
        },
        "15": {
            "label": "חניה 15",
            "x": 34.92,
            "y": 48.89,
            "width": 3.29,
            "height": 9.51
        },
        "16": {
            "label": "חניה 16",
            "x": 31.2,
            "y": 48.89,
            "width": 3.87,
            "height": 9.51
        },
        "17": {
            "label": "חניה 17",
            "x": 26.97,
            "y": 51.21,
            "width": 4.08,
            "height": 9.31
        },
        "18": {
            "label": "חניה 18",
            "x": 18.6,
            "y": 62.45,
            "width": 6.59,
            "height": 4.66
        },
        "19": {
            "label": "חניה 19",
            "x": 27.19,
            "y": 71.56,
            "width": 3.87,
            "height": 18.52
        },
        "20": {
            "label": "חניה 20",
            "x": 31.2,
            "y": 69.63,
            "width": 3.58,
            "height": 20.85
        },
        "21": {
            "label": "חניה 21",
            "x": 34.78,
            "y": 69.63,
            "width": 3.15,
            "height": 9.51
        },
        "22": {
            "label": "חניה 22",
            "x": 38,
            "y": 69.73,
            "width": 3.36,
            "height": 9.51
        },
        "23": {
            "label": "חניה 23",
            "x": 34.85,
            "y": 79.15,
            "width": 7.09,
            "height": 5.26
        },
        "24": {
            "label": "חניה 24",
            "x": 34.71,
            "y": 84.51,
            "width": 7.37,
            "height": 5.26
        },
        "25": {
            "label": "חניה 25",
            "x": 37.14,
            "y": 89.98,
            "width": 6.8,
            "height": 4.86
        },
        "26": {
            "label": "חניה 26",
            "x": 52.25,
            "y": 89.57,
            "width": 12.96,
            "height": 5.26
        },
        "27": {
            "label": "חניה 27",
            "x": 51.96,
            "y": 84.21,
            "width": 13.32,
            "height": 5.36
        },
        "28": {
            "label": "חניה 28",
            "x": 50.24,
            "y": 79.45,
            "width": 6.73,
            "height": 5.06
        },
        "29": {
            "label": "חניה 29",
            "x": 50.24,
            "y": 75,
            "width": 6.44,
            "height": 4.76
        },
        "30": {
            "label": "חניה 30",
            "x": 50.24,
            "y": 70.44,
            "width": 6.66,
            "height": 4.86
        },
        "31": {
            "label": "חניה 31",
            "x": 58.12,
            "y": 55.06,
            "width": 7.88,
            "height": 6.38
        },
        "32": {
            "label": "חניה 32",
            "x": 58.69,
            "y": 49.59,
            "width": 6.59,
            "height": 5.26
        },
        "33": {
            "label": "חניה 33",
            "x": 58.62,
            "y": 44.84,
            "width": 6.8,
            "height": 4.96
        },
        "34": {
            "label": "חניה 34",
            "x": 58.76,
            "y": 38.87,
            "width": 6.59,
            "height": 5.47
        },
        "35": {
            "label": "חניה 35",
            "x": 58.69,
            "y": 34.21,
            "width": 6.94,
            "height": 5.16
        },
        "36": {
            "label": "חניה 36",
            "x": 58.76,
            "y": 29.65,
            "width": 6.52,
            "height": 4.96
        },
        "37": {
            "label": "חניה 37",
            "x": 58.83,
            "y": 24.29,
            "width": 6.59,
            "height": 5.06
        },
        "38": {
            "label": "חניה 38",
            "x": 58.76,
            "y": 19.13,
            "width": 6.44,
            "height": 5.26
        },
        "39": {
            "label": "חניה 39",
            "x": 65.49,
            "y": 18.62,
            "width": 6.3,
            "height": 5.67
        },
        "40": {
            "label": "חניה 40",
            "x": 65.56,
            "y": 24.19,
            "width": 6.52,
            "height": 4.96
        },
        "41": {
            "label": "חניה 41",
            "x": 65.35,
            "y": 29.96,
            "width": 6.8,
            "height": 4.45
        },
        "42": {
            "label": "חניה 42",
            "x": 65.42,
            "y": 34.51,
            "width": 6.66,
            "height": 4.66
        },
        "43": {
            "label": "חניה 43",
            "x": 65.2,
            "y": 38.16,
            "width": 7.09,
            "height": 6.07
        },
        "44": {
            "label": "חניה 44",
            "x": 65.2,
            "y": 44.63,
            "width": 6.73,
            "height": 5.26
        },
        "45": {
            "label": "חניה 45",
            "x": 65.42,
            "y": 49.59,
            "width": 6.37,
            "height": 5.16
        },
        "46": {
            "label": "חניה 46",
            "x": 66.21,
            "y": 59.61,
            "width": 7.02,
            "height": 5.57
        },
        "47": {
            "label": "חניה 47",
            "x": 66.28,
            "y": 65.18,
            "width": 6.94,
            "height": 4.76
        },
        "48": {
            "label": "חניה 48",
            "x": 65.2,
            "y": 73.38,
            "width": 6.87,
            "height": 5.26
        },
        "49": {
            "label": "חניה 49",
            "x": 65.28,
            "y": 78.84,
            "width": 6.73,
            "height": 5.06
        },
        "50": {
            "label": "חניה 50",
            "x": 65.35,
            "y": 84.82,
            "width": 6.8,
            "height": 4.76
        },
        "51": {
            "label": "חניה 51",
            "x": 65.28,
            "y": 89.47,
            "width": 6.8,
            "height": 5.06
        },
        "52": {
            "label": "חניה 52",
            "x": 80.6,
            "y": 89.57,
            "width": 6.59,
            "height": 5.16
        },
        "53": {
            "label": "חניה 53",
            "x": 80.38,
            "y": 84.51,
            "width": 6.8,
            "height": 5.26
        },
        "54": {
            "label": "חניה 54",
            "x": 80.45,
            "y": 79.55,
            "width": 6.8,
            "height": 5.16
        },
        "55": {
            "label": "חניה 55",
            "x": 80.6,
            "y": 75.1,
            "width": 6.87,
            "height": 4.55
        },
        "56": {
            "label": "חניה 56",
            "x": 80.45,
            "y": 70.14,
            "width": 6.87,
            "height": 5.06
        },
        "57": {
            "label": "חניה 57",
            "x": 80.96,
            "y": 64.67,
            "width": 6.44,
            "height": 5.47
        },
        "58": {
            "label": "חניה 58",
            "x": 80.81,
            "y": 60.42,
            "width": 6.87,
            "height": 4.35
        },
        "59": {
            "label": "חניה 59",
            "x": 81.03,
            "y": 55.57,
            "width": 6.59,
            "height": 4.96
        },
        "60": {
            "label": "חניה 60",
            "x": 80.24,
            "y": 50.5,
            "width": 6.37,
            "height": 4.86
        },
        "61": {
            "label": "חניה 61",
            "x": 79.88,
            "y": 45.85,
            "width": 6.87,
            "height": 4.76
        },
        "62": {
            "label": "חניה 62",
            "x": 79.95,
            "y": 40.89,
            "width": 6.59,
            "height": 5.16
        },
        "63": {
            "label": "חניה 63",
            "x": 80.1,
            "y": 35.53,
            "width": 6.59,
            "height": 4.96
        },
        "64": {
            "label": "חניה 64",
            "x": 79.88,
            "y": 31.07,
            "width": 6.73,
            "height": 4.55
        },
        "65": {
            "label": "חניה 65",
            "x": 80.1,
            "y": 26.11,
            "width": 6.59,
            "height": 5.06
        },
        "66": {
            "label": "חניה 66",
            "x": 80.1,
            "y": 20.55,
            "width": 6.44,
            "height": 4.96
        },
        "67": {
            "label": "חניה 67",
            "x": 79.95,
            "y": 16.4,
            "width": 6.8,
            "height": 4.35
        },
        "68": {
            "label": "חניה 68",
            "x": 80.03,
            "y": 11.74,
            "width": 6.52,
            "height": 4.76
        }

  },

  warehouses: {
        "1": {
            "label": "מחסן 1",
            area: 0, // dummy for now
            mapKey: 'basement', // basement | ground | floor | floor8
            "x": 40.22,
            "y": 34.61,
            "width": 1.86,
            "height": 4.55
        },
        "2": {
            "label": "מחסן 2",
            area: 0, // dummy for now
            mapKey: 'basement', // basement | ground | floor | floor8
            "x": 36.57,
            "y": 38.87,
            "width": 5.37,
            "height": 2.83
        },
        "3": {
            "label": "מחסן 3",
            area: 0, // dummy for now
            mapKey: 'basement', // basement | ground | floor | floor8
            "x": 36.5,
            "y": 41.8,
            "width": 5.51,
            "height": 2.94
        },
        "4": {
            "label": "מחסן 4",
            area: 0, // dummy for now
            mapKey: 'basement', // basement | ground | floor | floor8
            "x": 33.35,
            "y": 38.87,
            "width": 3.22,
            "height": 5.97
        },
        "5": {
            "label": "מחסן 5",
            area: 0, // dummy for now
            mapKey: 'basement', // basement | ground | floor | floor8
            "x": 30.2,
            "y": 39.57,
            "width": 3.22,
            "height": 5.36
        },
        "7": {
            "label": "מחסן 7",
            area: 0, // dummy for now
            mapKey: 'basement', // basement | ground | floor | floor8            
            "x": 32.2,
            "y": 34.11,
            "width": 3.15,
            "height": 5.16
        },
        "8": {
            "label": "מחסן 8",
            area: 0, // dummy for now
            mapKey: 'basement', // basement | ground | floor | floor8
            "x": 26.76,
            "y": 43.62,
            "width": 4.58,
            "height": 3.44
        },
        "9": {
            "label": "מחסן 9",
            area: 0, // dummy for now
            mapKey: 'basement', // basement | ground | floor | floor8
            "x": 26.9,
            "y": 46.76,
            "width": 4.15,
            "height": 4.15
        },
        "10": {
            "label": "מחסן 10",
            area: 0, // dummy for now
            mapKey: 'basement', // basement | ground | floor | floor8
            "x": 23.47,
            "y": 43.52,
            "width": 3.36,
            "height": 5.87
        },
        "11": {
            "label": "מחסן 11",
            area: 0, // dummy for now
            mapKey: 'basement', // basement | ground | floor | floor8
            "x": 24.97,
            "y": 49.49,
            "width": 1.86,
            "height": 8
        },
        "12": {
            "label": "מחסן 12",
            area: 0, // dummy for now
            mapKey: 'basement', // basement | ground | floor | floor8
            "x": 15.95,
            "y": 59.71,
            "width": 2.65,
            "height": 5.26
        },
        "13": {
            "label": "מחסן 13",
            area: 0, // dummy for now
            mapKey: 'basement', // basement | ground | floor | floor8
            "x": 14.23,
            "y": 59.51,
            "width": 1.86,
            "height": 7.49
        },
        "14": {
            "label": "מחסן 14",
            area: 0, // dummy for now
            mapKey: 'basement', // basement | ground | floor | floor8
            "x": 14.3,
            "y": 66.9,
            "width": 1.79,
            "height": 6.17
        },
        "15": {
            "label": "מחסן 15",
            area: 0, // dummy for now
            mapKey: 'basement', // basement | ground | floor | floor8
            "x": 14.23,
            "y": 72.97,
            "width": 1.86,
            "height": 6.07
        },
        "16": {
            "label": "מחסן 16",
            area: 0, // dummy for now
            mapKey: 'basement', // basement | ground | floor | floor8
            "x": 14.37,
            "y": 78.94,
            "width": 3.44,
            "height": 3.74
        },
        "17": {
            "label": "מחסן 17",
            area: 0, // dummy for now
            mapKey: 'basement', // basement | ground | floor | floor8
            "x": 56.97,
            "y": 78.94,
            "width": 2.79,
            "height": 4.96
        },
        "18": {
            "label": "מחסן 18",
            area: 0, // dummy for now
            mapKey: 'basement', // basement | ground | floor | floor8
            "x": 60.26,
            "y": 76.52,
            "width": 5.01,
            "height": 4.25
        },
        "19": {
            "label": "מחסן 19",
            area: 0, // dummy for now
            mapKey: 'basement', // basement | ground | floor | floor8
            "x": 60.34,
            "y": 80.77,
            "width": 4.8,
            "height": 3.74
        },
        "20": {
            "label": "מחסן 20",
            area: 0, // dummy for now
            mapKey: 'basement', // basement | ground | floor | floor8
            "x": 53.11,
            "y": 61.74,
            "width": 4.22,
            "height": 4.45
        },
        "21": {
            "label": "מחסן 21",
            area: 0, // dummy for now
            mapKey: 'basement', // basement | ground | floor | floor8
            "x": 41.44,
            "y": 27.93,
            "width": 2.79,
            "height": 4.55
        },
        "22": {
            "label": "מחסן 22",
            area: 0, // dummy for now
            mapKey: 'basement', // basement | ground | floor | floor8
            "x": 65.56,
            "y": 55.46,
            "width": 5.37,
            "height": 4.35
        },
        "23": {
            "label": "מחסן 23",
            area: 0, // dummy for now
            mapKey: 'ground', // basement | ground | floor | floor8
            "x": 54.25,
            "y": 37.35,
            "width": 1.86,
            "height": 6.07
        },
        "24": {
            "label": "מחסן 24",
            area: 0, // dummy for now
            mapKey: 'ground', // basement | ground | floor | floor8
            "x": 41.22,
            "y": 33.91,
            "width": 2.29,
            "height": 9.51
        },
        "25": {
            "label": "מחסן 25",
            area: 0, // dummy for now
            mapKey: 'ground', // basement | ground | floor | floor8
            "x": 38.79,
            "y": 37.85,
            "width": 2.43,
            "height": 5.77
        },
        "26": {
            "label": "מחסן 26",
            area: 0, // dummy for now
            mapKey: 'ground', // basement | ground | floor | floor8
            "x": 36.85,
            "y": 38.06,
            "width": 1.86,
            "height": 5.47
        },
        "27": {
            "label": "מחסן 27",
            area: 0, // dummy for now
            mapKey: 'ground', // basement | ground | floor | floor8
            "x": 35.14,
            "y": 37.95,
            "width": 1.79,
            "height": 5.57
        },
        "28": {
            "label": "מחסן 28",
            area: 0, // dummy for now
            mapKey: 'ground', // basement | ground | floor | floor8
            "x": 33.42,
            "y": 37.85,
            "width": 1.72,
            "height": 5.67
        },
        "29": {
            "label": "מחסן 29",
            area: 0, // dummy for now
            mapKey: 'ground', // basement | ground | floor | floor8            
            "x": 32.92,
            "y": 33.5,
            "width": 2.36,
            "height": 4.66
        },
        "30": {
            "label": "מחסן 30",
            area: 0, // dummy for now
            mapKey: 'ground', // basement | ground | floor | floor8
            "x": 35.14,
            "y": 33.4,
            "width": 2.36,
            "height": 4.86
        },
        "31": {
            "label": "מחסן 31",
            area: 0, // dummy for now
            mapKey: 'ground', // basement | ground | floor | floor8
            "x": 29.12,
            "y": 42,
            "width": 4.51,
            "height": 3.95
        },
        "32": {
            "label": "מחסן 32",
            area: 0, // dummy for now
            mapKey: 'ground', // basement | ground | floor | floor8
            "x": 29.12,
            "y": 45.75,
            "width": 4.37,
            "height": 3.74
        },
        "34": {
            "label": "מחסן 34",
            area: 0, // dummy for now
            mapKey: 'ground', // basement | ground | floor | floor8
            "x": 56.18,
            "y": 71.86,
            "width": 2.29,
            "height": 9.21
        },
        "35": {
            "label": "מחסן 35",
            area: 0, // dummy for now
            mapKey: 'ground', // basement | ground | floor | floor8            
            "x": 53.68,
            "y": 63.05,
            "width": 4.65,
            "height": 3.34
        },
        "36": {
            "label": "מחסן 36",
            area: 0, // dummy for now
            mapKey: 'ground', // basement | ground | floor | floor8
            "x": 53.82,
            "y": 69.33,
            "width": 2.51,
            "height": 6.38
        },
        "37": {
            "label": "מחסן 37",
            area: 0, // dummy for now
            mapKey: 'ground', // basement | ground | floor | floor8
            "x": 58.26,
            "y": 75.5,
            "width": 2.72,
            "height": 5.47
        },
        "38": {
            "label": "מחסן 38",
            area: 0, // dummy for now
            mapKey: 'ground', // basement | ground | floor | floor8            
            "x": 57.97,
            "y": 61.74,
            "width": 4.58,
            "height": 4.76
        },
        "39": {
            "label": "מחסן 39",
            area: 0, // dummy for now
            mapKey: 'floor', // basement | ground | floor | floor8
            "x": 28.83,
            "y": 30.16,
            "width": 3.08,
            "height": 6.98
        },
        "40": {
            "label": "מחסן 40",
            area: 0, // dummy for now
            mapKey: 'floor', // basement | ground | floor | floor8
            "x": 31.63,
            "y": 38.76,
            "width": 2.36,
            "height": 4.76
        },
        "41": {
            "label": "מחסן 41",
            area: 0, // dummy for now
            mapKey: 'floor', // basement | ground | floor | floor8
            "x": 33.92,
            "y": 36.03,
            "width": 2.22,
            "height": 7.49
        },
        "42": {
            "label": "מחסן 42",
            area: 0, // dummy for now
            mapKey: 'floor', // basement | ground | floor | floor8
            "x": 28.83,
            "y": 30.16,
            "width": 3.08,
            "height": 6.98
        },
        "43": {
            "label": "מחסן 43",
            area: 0, // dummy for now
            mapKey: 'floor', // basement | ground | floor | floor8
            "x": 31.63,
            "y": 38.76,
            "width": 2.36,
            "height": 4.76
        },
        "44": {
            "label": "מחסן 44",
            area: 0, // dummy for now
            mapKey: 'floor', // basement | ground | floor | floor8
            "x": 33.92,
            "y": 36.03,
            "width": 2.22,
            "height": 7.49
        },
        "45": {
            "label": "מחסן 45",
            area: 0, // dummy for now
            mapKey: 'floor', // basement | ground | floor | floor8
            "x": 28.83,
            "y": 30.16,
            "width": 3.08,
            "height": 6.98
        },
        "46": {
            "label": "מחסן 46",
            area: 0, // dummy for now
            mapKey: 'floor', // basement | ground | floor | floor8
            "x": 31.63,
            "y": 38.76,
            "width": 2.36,
            "height": 4.76
        },
        "47": {
            "label": "מחסן 47",
            area: 0, // dummy for now
            mapKey: 'floor', // basement | ground | floor | floor8
            "x": 33.92,
            "y": 36.03,
            "width": 2.22,
            "height": 7.49
        },        
        "48": {
            "label": "מחסן 48",
            area: 0, // dummy for now
            mapKey: 'floor', // basement | ground | floor | floor8
            "x": 28.83,
            "y": 30.16,
            "width": 3.08,
            "height": 6.98
        },
        "49": {
            "label": "מחסן 49",
            area: 0, // dummy for now
            mapKey: 'floor', // basement | ground | floor | floor8
            "x": 31.63,
            "y": 38.76,
            "width": 2.36,
            "height": 4.76
        },
        "50": {
            "label": "מחסן 50",
            area: 0, // dummy for now
            mapKey: 'floor', // basement | ground | floor | floor8
            "x": 33.92,
            "y": 36.03,
            "width": 2.22,
            "height": 7.49
        },        
        "51": {
            "label": "מחסן 51",
            area: 0, // dummy for now
            mapKey: 'floor', // basement | ground | floor | floor8
            "x": 28.83,
            "y": 30.16,
            "width": 3.08,
            "height": 6.98
        },
        "52": {
            "label": "מחסן 52",
            area: 0, // dummy for now
            mapKey: 'floor', // basement | ground | floor | floor8
            "x": 31.63,
            "y": 38.76,
            "width": 2.36,
            "height": 4.76
        },
        "53": {
            "label": "מחסן 53",
            area: 0, // dummy for now
            mapKey: 'floor', // basement | ground | floor | floor8
            "x": 33.92,
            "y": 36.03,
            "width": 2.22,
            "height": 7.49
        },        
        "54": {
            "label": "מחסן 54",
            area: 0, // dummy for now
            mapKey: 'floor', // basement | ground | floor | floor8
            "x": 28.83,
            "y": 30.16,
            "width": 3.08,
            "height": 6.98
        },
        "55": {
            "label": "מחסן 55",
            area: 0, // dummy for now
            mapKey: 'floor', // basement | ground | floor | floor8
            "x": 31.63,
            "y": 38.76,
            "width": 2.36,
            "height": 4.76
        },
        "56": {
            "label": "מחסן 56",
            area: 0, // dummy for now
            mapKey: 'floor', // basement | ground | floor | floor8
            "x": 33.92,
            "y": 36.03,
            "width": 2.22,
            "height": 7.49
        },        
        "57": {
            "label": "מחסן 57",
            area: 0, // dummy for now
            mapKey: 'floor', // basement | ground | floor | floor8
            "x": 28.83,
            "y": 30.16,
            "width": 3.08,
            "height": 6.98
        },
        "58": {
            "label": "מחסן 58",
            area: 0, // dummy for now
            mapKey: 'floor', // basement | ground | floor | floor8
            "x": 31.63,
            "y": 38.76,
            "width": 2.36,
            "height": 4.76
        },
        "59": {
            "label": "מחסן 59",
            area: 0, // dummy for now
            mapKey: 'floor', // basement | ground | floor | floor8
            "x": 33.92,
            "y": 36.03,
            "width": 2.22,
            "height": 7.49
        },
        "61": {
            "label": "מחסן 61",
            area: 0, // dummy for now
            mapKey: 'floor8', // basement | ground | floor | floor8
            "x": 36.07,
            "y": 24,
            "width": 3.44,
            "height": 9.92
        },
        "62": {
            "label": "מחסן 62",
            area: 0, // dummy for now
            mapKey: 'floor8', // basement | ground | floor | floor8
            "x": 75.44,
            "y": 63.7,
            "width": 3.44,
            "height": 12.15
        },
        "63": {
            "label": "מחסן 63",
            area: 0, // dummy for now
            mapKey: 'floor8', // basement | ground | floor | floor8
            "x": 65.35,
            "y": 63.49,
            "width": 3.15,
            "height": 12.25
        },
        "64": {
            "label": "מחסן 64",
            area: 0, // dummy for now
            mapKey: 'basement', // basement | ground | floor | floor8
            "x": 62.41,
            "y": 72.26,
            "width": 2.94,
            "height": 4.15
        },
        "65": {
            "label": "מחסן 65",
            area: 0, // dummy for now
            mapKey: 'basement', // basement | ground | floor | floor8
            "x": 39.86,
            "y": 24.9,
            "width": 4.37,
            "height": 3.44
        },
        "66": {
            "label": "מחסן 66",
            area: 0, // dummy for now
            mapKey: 'basement', // basement | ground | floor | floor8
            "x": 41.72,
            "y": 18.83,
            "width": 2.29,
            "height": 6.07
        }
  },
}